import { t } from "@lingui/macro";
import { useLinkProps } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useTrackEvent } from "@/utils/Analytics/Mixpanel/hooks/useTrackEvent";
import DepartmentIcon from "@whoosh/design-system/src/components/icons_v2/department/components/DepartmentIcon";
import {
  Text,
  VStack,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";
import { useTodaysDate } from "@whoosh/utilities/src/dates";

import { FacilityCard_Facility$key } from "./__generated__/FacilityCard_Facility.graphql";

type FacilityCardProps = {
  facilityRef: FacilityCard_Facility$key | null;
};

export const FacilityCard = ({ facilityRef }: FacilityCardProps) => {
  const facility = useFragment(FacilityCardFragmentString, facilityRef);
  const departmentType = facility?.department?.type || "GOLF";

  const isDining = departmentType === "DINING";

  const curDate = useTodaysDate();

  const facilitySlug = isDining ? "dining" : facility?.slug;
  const { onPress: onUrlPress } = useLinkProps({
    screen: "Agenda",
    params: {
      facilitySlug: facilitySlug,
      date: curDate,
    },
  });

  const name = isDining
    ? t`Dining`
    : facility?.name
    ? facility?.name === "Golf Course"
      ? t`Golf`
      : facility?.name
    : "";

  const trackEvent = useTrackEvent();
  return (
    <VStack>
      <Pressable
        onPress={() => {
          onUrlPress();
          trackEvent("Homepage.BookTodayFacilityCTAClicked", {
            facilitySlug: facility?.slug ?? "",
          });
        }}
      >
        <VStack
          backgroundColor="surface-main-primary-subtlest"
          width={96}
          height={96}
          justifyContent="center"
          alignItems="center"
          borderRadius="4"
          flexDirection="column"
          gap={3}
        >
          <DepartmentIcon type={departmentType} />
          <Text
            maxFontSizeMultiplier={1.25}
            variant="mainSmallSemiBold"
            textAlign="center"
          >
            {name}
          </Text>
        </VStack>
      </Pressable>
    </VStack>
  );
};

const FacilityCardFragmentString = graphql`
  fragment FacilityCard_Facility on Facility {
    id
    name
    slug
    type
    ...getFacilityMemberPermissions_facility
    department {
      type
    }
  }
`;
